<template>
	<div>
		<v-row>
			<v-col cols="12" md="12">
				<v-chip class="ma-2" color="success" outlined>
					<v-icon left>
						mdi-account-outline
					</v-icon>
					{{ data.member.fullName }}
				</v-chip>
				<v-chip class="ma-2" color="success" outlined>
					<v-icon left>
						mdi-account-outline
					</v-icon>
					کد پرسنلی: {{ data.member.personalCode }}
				</v-chip>
				<v-chip class="ma-2" color="success" outlined>
					<v-icon left>
						mdi-cash
					</v-icon>
					موجودی پس انداز: {{ totalSavedMoney.toString().toPriceFormat() }} تومان
				</v-chip>
			</v-col>
		</v-row>
		<v-divider class="mb-3" />
		<div>
			<v-data-table :headers="headers" :items="userSavedMonies" :items-per-page="500" class="elevation-1 mb-3">
				<template v-slot:item="row">
					<tr>
						<td class="text-center">
							{{ row.item.amount.toString().toPriceFormat() }} تومان
						</td>
						<td class="text-right">
							{{ row.item.description }}
						</td>
						<td class="text-center">
							{{ row.item.savedBy }}
						</td>
						<td class="text-center">
							{{ row.item.saveDate_Persian }}
						</td>
						<td class="text-center">
							<v-btn class="mx-2" fab dark small color="secondary" @click="edit(row.item)">
								<v-icon dark>
									mdi-square-edit-outline
								</v-icon>
							</v-btn>
							<v-btn class="mx-2" fab dark small color="pink" @click="remove(row.item)">
								<v-icon dark>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</td>
					</tr>
				</template>
			</v-data-table>
			<v-row>
				<v-col cols="12" md="12" class="text-center">
					<v-btn class="mx-auto" color="green" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						ثبت پس انداز
					</v-btn>
				</v-col>
			</v-row>
		</div>

		<v-dialog v-model="dialogModifyUserSavedMoney" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت پس انداز</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserSavedMoney = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-saved-money ref="modifyUserSavedMoeny" :data="selectedUserSavedMoney" @callbck="callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import ModifyUserSavedMoney from './ModifyUserSavedMoney.vue'

	export default {
		name: 'ManageSavedMoneyView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-user-saved-money': ModifyUserSavedMoney,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				totalSavedMoney: 0,
				errorMessages: '',
				dialogModifyUserSavedMoney: false,
				selectedUserSavedMoney: null,
				userSavedMonies: [],
				headers: [{
					text: 'مبلغ',
					align: 'center',
					sortable: true,
					value: 'amount',
				}, {
					text: 'توضیحات',
					align: 'right',
					sortable: true,
					value: 'description',
				}, {
					text: 'ثبت توسط',
					align: 'center',
					sortable: true,
					value: 'savedBy',
				}, {
					text: 'تاریخ ثبت',
					align: 'center',
					sortable: true,
					value: 'saveDate_Persian',
				}, {
					text: 'عملیات ها',
					align: 'center',
					sortable: false,
					width: 200,
				},
				],
			}
		},
		mounted() {
		},
		methods: {
			add() {
				this.dialogModifyUserSavedMoney = true
				this.selectedUserSavedMoney = { id: emptyId, memberId: this.data.member.id }
				this.$nextTick(() => {
					this.$refs.modifyUserSavedMoeny.prepareData()
				})
			},
			edit(item) {
				this.dialogModifyUserSavedMoney = true
				this.selectedUserSavedMoney = { id: item.id }
				this.$nextTick(() => {
					this.$refs.modifyUserSavedMoeny.prepareData()
				})
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/userSavedMoney/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			loadData() {
				this.activeTab = 0
				api.get('admin/userSavedMoney/GetSavedMoniesByUserId/' + this.data.member.id, null)
					.then(
						response => {
							this.userSavedMonies = response
							var sum = 0
							for (let index = 0; index < this.userSavedMonies.length; index++) {
								sum += this.userSavedMonies[index].amount
							}
							this.totalSavedMoney = sum
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			callbck(result) {
				this.dialogModifyUserSavedMoney = false
				if (result) { this.loadData() }
			},
		},
	}
</script>
<style>
</style>
